export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_08-496a61f7f0e74df87c4bf7794ea63152.jpg";